const departments = [
  { resourceId: 'A', title: 'Activity', titlePrefix: 'ACT: ' },
  { resourceId: 'G', title: 'Government', titlePrefix: 'GOV: ' },
  { resourceId: 'L', title: 'Legislature', titlePrefix: 'LEG: ' },
  { resourceId: 'H', title: 'HTOL', titlePrefix: 'HTOL: ' },
  { resourceId: 'N', title: 'NCOP', titlePrefix: 'NCOP: ' },
];

export default departments;
